import { ROLES_OFFERED, WORKER_ROLES_OFFERED } from "@shyne/shared";
import { settableMemberStatus, type MembershipRole, type MembershipStatus } from "@shyne/shared/api";
import { organization_type } from "@/models/organization.model";

export function rolesOfferedBy(type: organization_type | undefined): readonly MembershipRole[] {
  if (type === undefined) return [];
  if (type === organization_type.emp) return WORKER_ROLES_OFFERED;
  return ROLES_OFFERED[type];
}

export function roleLabel(role: MembershipRole, type: organization_type | undefined): string {
  if (role === "admin") return type === organization_type.pmc ? "Customer admin" : "Admin";
  if (role === "propertyManager") return "Property manager";
  return "Member";
}

export const roleOptions = (type: organization_type | undefined) => rolesOfferedBy(type).map((role) => ({ label: roleLabel(role, type), value: role }));

export type MemberEdits = { role: boolean; status: boolean };

export const editsOf = (type: organization_type | undefined, status: MembershipStatus | undefined): MemberEdits => ({
  role: rolesOfferedBy(type).length > 1,
  status: settableMemberStatus.safeParse(status).success,
});

export function editTitleOf({ role, status }: MemberEdits): string | null {
  if (role && status) return "Edit Role & Status";
  if (role) return "Edit Role";
  if (status) return "Edit Status";
  return null;
}
